import { makeStyles, Theme } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    contentToolbar: {
      [theme.breakpoints.up('lg')]: {
        height: 64,
      },
      height: 128,
    },
    content: {
      flexGrow: 1,
      paddingTop: '64px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '57px',
      },
      // paddingBottom: '49px',
      height: '100vh',

      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 260px)',
        paddingBottom: 0,
      },

      [theme.breakpoints.up('lg')]: {
        width: 'auto',
        paddingBottom: 0,
      },
    },
    page: {
      position: 'relative',
      overflow: 'auto',
      height: 'calc(100vh - 64px)',
      [theme.breakpoints.down(1025)]: {
        height: 'calc(100vh - 120px)',
        padding: '0 20px',
      },
      [theme.breakpoints.down(420)]: {
        height: '100%',
        paddingBottom: '150px',
      },
      '& blockquote': {
        paddingLeft: '20px',
        paddingRight: '8px',
        borderLeftWidth: '5px',
        fontStyle: 'italic',
        fontFamily: 'Georgia, Times, "Times New Roman", serif',
        padding: '2px 0',
        borderStyle: 'solid',
        borderColor: '#ccc',
        borderWidth: '0',
      },
    },
  }),
)

export default useStyles
